var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ABB4BC;}.cls-2{fill:#ABB4BC;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "b") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.28325,57.0136H25.581a2.30233,2.30233,0,1,0,0,4.60466H46.28325a2.30233,2.30233,0,1,0,0-4.60466Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.11954,61.61826a2.30233,2.30233,0,0,0,0-4.60466H57.457a2.30233,2.30233,0,0,0-.00033,4.60466Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.28325,92.84847H25.581a2.30224,2.30224,0,1,0,0,4.60448H46.28325a2.30224,2.30224,0,1,0,0-4.60448Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.154,95.1524a2.3011,2.3011,0,0,0,2.30378,2.29887H77.28l-.07844-4.60262H57.45777A2.30737,2.30737,0,0,0,55.154,95.1524Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.28325,74.931H25.581a2.30239,2.30239,0,1,0,0,4.60478H46.28325a2.30239,2.30239,0,0,0,0-4.60478Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.4218,77.23337a2.305,2.305,0,0,0-2.30225-2.3024H57.457a2.30239,2.30239,0,0,0-.00033,4.60478H79.11954A2.30493,2.30493,0,0,0,81.4218,77.23337Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.58765,98.85317v12.19039a3.55521,3.55521,0,0,1-3.55369,3.54879H13.00474a3.55521,3.55521,0,0,1-3.55369-3.54879V39.74912H24.29322A11.5181,11.5181,0,0,0,35.79739,28.24494V13.40278H92.034a3.55625,3.55625,0,0,1,3.55369,3.55369V59.9586l7.95048-12.36194V16.95647A11.5118,11.5118,0,0,0,92.034,5.45229H31.82217a4.00894,4.00894,0,0,0-2.81845,1.16659l-6.75448,6.78389L9.45105,26.25978,3.28968,32.45056a3.97661,3.97661,0,0,0-1.78911,3.32333v75.26966a11.51807,11.51807,0,0,0,11.50418,11.50415H92.034a11.51492,11.51492,0,0,0,11.50418-11.50415V86.80982L96.78856,97.30423A11.26152,11.26152,0,0,1,95.58765,98.85317Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.59843,91.93l.12368,7.28135L80.746,100.729a1.0326,1.0326,0,1,0,1.73688,1.11729l.97623-1.51755,6.67706-2.907a6.65935,6.65935,0,0,0,2.9426-2.50333l28.497-44.30353a6.1963,6.1963,0,0,0-10.42264-6.7041l-28.497,44.30353A6.65958,6.65958,0,0,0,81.59843,91.93Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.78824,52.65782a1.54893,1.54893,0,0,0-2.14064.46476L109.67973,74.838a1.54894,1.54894,0,0,0,2.60544,1.67588L126.253,54.79847A1.54894,1.54894,0,0,0,125.78824,52.65782Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.f8559753.svg";
export { ForwardRef as ReactComponent };